// index.js
import { Routes, Route } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected from "./AuthProtected";
import 'leaflet/dist/leaflet.css';


const AllRoutes = () => {
  return (
    <Routes>
      {publicRoutes.map(({ path, component }, i) => (
        <Route key={i} path={path} element={component} />
      ))}

      {authProtectedRoutes.map(({ path, component }, i) => (
        <Route
          key={i}
          path={path}
          element={<AuthProtected>{component}</AuthProtected>}
        />
      ))}
    </Routes>
  );
};

export default AllRoutes;
